type Props = { title: string; sub?: string };

export default function SubTabLoading({ title, sub }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 24px',
        color: '#8a95a5',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '4px solid #e0e4e8',
          borderTopColor: '#2a5a8c',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          marginBottom: 16,
        }}
      />
      <div style={{ fontSize: 15, fontWeight: 600, color: '#5a6a7a' }}>{title}</div>
      {sub && <div style={{ fontSize: 12, color: '#b0b8c4', marginTop: 4 }}>{sub}</div>}
    </div>
  );
}
